import { useState } from 'react';
import './LandingPageInt.scss';
import useDevicePermissions from '../hooks/useDevicePermissions';
import LandingCameraPermissionDenied from './LandingCameraPermissionDenied';


export default function LandingPageInt({ onEnterExperience, shouldFadeIn = false }) {
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [showPermissionDenied, setShowPermissionDenied] = useState(false);
  const { error, requestPermissions } = useDevicePermissions();

  const handleEnterExperience = async () => {
    const granted = await requestPermissions();
    
    if (!granted) {
      setShowPermissionDenied(true);
      return;
    }

    setIsFadingOut(true);
    if (onEnterExperience) {
      onEnterExperience(true);
    }
  };

  const handleContinueWithoutPermission = () => {
    setShowPermissionDenied(false);
    setIsFadingOut(true);
    if (onEnterExperience) {
      onEnterExperience(false);
    }
  };

  const handleRetryPermissions = async () => {
    const granted = await requestPermissions();
    if (granted) {
      setShowPermissionDenied(false);
      setIsFadingOut(true);
      if (onEnterExperience) {
        onEnterExperience(true);
      }
    }
  };

  if (showPermissionDenied) {
    return (
      <LandingCameraPermissionDenied 
        onContinue={handleContinueWithoutPermission}
        onRetry={handleRetryPermissions}
      />
    );
  }

  return (
    <div className={`landing-page-int ${isFadingOut ? 'landing-page-int--fade-out' : ''} ${shouldFadeIn ? 'landing-page-int--fade-in' : ''}`}>
      <div className="landing-page-int__logo">
        <img src="/images/logo.svg" alt="Joby Logo" />
      </div>

      <h1 className="landing-page-int__headline">
        Skip traffic.
        <br />
        Time to fly.
      </h1>

      <div className="landing-page-int__description">
        <p>
          {/*<span className="landing-page-int__hotspots-toggle">
              <span className="landing-page-int__hotspots-toggle-dot"></span>
              Hotspots
            </span>*/}
          Step inside the Joby aircraft and see the future of travel.
        </p>
      </div>
      <div className="landing-page-int__cta-container">
        <button
          className="landing-page-int__cta"
          onClick={handleEnterExperience}
        >
          Go Up
        </button>
        <div className="landing-page-int__disclaimer">
          <p>Not currently available. Coming soon to select city skies.</p>
        </div>
      </div>
    </div>
  );
}

